import React from "react";
import { Button, Icon, Menu, Modal, ModalHeader } from "semantic-ui-react";
import { Reducers, ReduxReusableComponents, RRCProps, State } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { ModalExt } from "@crispico/foundation-react/components/ModalExt/ModalExt";
import { taskEntityDescriptor } from "AppEntityDescriptors";
import { AssociationFieldEditor } from "@crispico/foundation-react/entity_crud/fieldEditors/AssociationFieldEditor";
import { apolloClientHolder, FieldDescriptor } from "@crispico/foundation-react";
import { UNASSIGN_TASKS } from "./queries";
import { ID } from "@crispico/foundation-react/entity_crud/entityCrudConstants";
import { SelectExtOption } from "@crispico/foundation-react/components/selectExt/SelectExt";
import { components, ControlProps } from "react-select";

export enum UNASSIGN_MODE {
    NORMAL, MENU_ITEM
}

enum MODAL_TYPE {
    NORMAL = "NORMAL",
    CONFIRMATION = "CONFIRMATION",
}

class TaskAssociationFieldEditor extends AssociationFieldEditor<{ tasks: any[] }> {

    protected async performQuery(searchQuery?: string, _?: string) {
        let tasks = this.props.tasks;
        if (searchQuery) {
            tasks = this.props.tasks.filter(task => task.name && task.name.toLowerCase().includes(searchQuery.toLowerCase()));

        }
        this.setState({ entities: tasks });
    }

    protected renderExtraButtons({ children, ...props }: ControlProps<SelectExtOption>) {
        return (<components.Control {...props}>
            {children}
        </components.Control>);
    };
}

export class UnassignButtonState extends State {
    openModal?: MODAL_TYPE;
    selectedTasks: any[] = [];
}

export class UnassignButtonReducers extends Reducers<UnassignButtonState> { }

export type UnassignButtonProps = RRCProps<UnassignButtonState, UnassignButtonReducers> & { disabled?: boolean, mode?: UNASSIGN_MODE, tasks: Array<any>, onUnassign?: () => void };

export class UnassignButton extends React.Component<UnassignButtonProps> {

    fdTask: FieldDescriptor = new FieldDescriptor();

    constructor(props: UnassignButtonProps) {
        super(props);
        this.fdTask.name = "tasks";
        this.fdTask.type = "Task";
        this.onClick = this.onClick.bind(this);
        this.okHandler = this.okHandler.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    protected onClick(e: React.MouseEvent<HTMLElement, MouseEvent>) {
        e.preventDefault(); // see EntityEditorFormSimple.renderFormikChild
        this.props.r.setInReduxState({ openModal: MODAL_TYPE.NORMAL })
    }

    protected async okHandler() {
        if (this.props.s.openModal == MODAL_TYPE.CONFIRMATION) {
            await apolloClientHolder.apolloClient.mutate({ mutation: UNASSIGN_TASKS, variables: { taskIds: this.props.s.selectedTasks.map(task => task[ID]) } });
            this.props.onUnassign?.call(null);
            this.closeModal();
        } else {
            this.props.r.setInReduxState({ openModal: MODAL_TYPE.CONFIRMATION });
        }
    }

    protected closeModal() {
        this.props.r.setInReduxState({ openModal: undefined, selectedTasks: [] });
    }

    protected renderModalContent() {
        if (this.props.s.openModal == MODAL_TYPE.CONFIRMATION) {
            return _msg("UnassignButton.confirmationMessage.label");
        }

        return <>
            <label>{taskEntityDescriptor.getIcon()}{taskEntityDescriptor.getLabel(true)}</label>
            <TaskAssociationFieldEditor
                isMulti={true}
                fieldDescriptor={this.fdTask}
                selectedValue={this.props.s.selectedTasks}
                tasks={this.props.tasks}
                onChange={value => {
                    this.props.r.setInReduxState({ selectedTasks: value });
                }}
            />
        </>
    }

    renderModal() {
        return <ModalExt size="tiny" style={{ whiteSpace: "pre-line" }} transparentDimmer={true} className="wh-auto"
            open={this.props.s.openModal ? true : false}
            onClose={this.closeModal}>
            <ModalHeader>{_msg(this.props.s.openModal == MODAL_TYPE.CONFIRMATION ? 'general.confirmation' : 'UnassignButton.selectTasksHeader.label')}</ModalHeader>
            <Modal.Content className="less-padding" style={{ maxHeight: "700px" }}>
                {this.renderModalContent()}
            </Modal.Content>
            <Modal.Actions>
                <Button key="ok" disabled={this.props.s.selectedTasks.length == 0} onClick={this.okHandler}>
                    {_msg(this.props.s.openModal == MODAL_TYPE.CONFIRMATION ? "general.ok" : "UnassignButton.unassign.label")}
                </Button>
                <Button key="cancel" onClick={this.closeModal}>{_msg("general.cancel")}</Button>
            </Modal.Actions>
        </ModalExt>
    }

    render() {
        let content, label = <>
            <Icon name='remove' />
            {_msg({ missingKeyStrategy: "RETURN_KEY" }, "UnassignButton.unassign.label")}
        </>;
        if (this.props.mode === UNASSIGN_MODE.MENU_ITEM) {
            content = <Menu.Item size="mini" color="red" disabled={this.props.disabled} onClick={this.onClick}>
                {label}
            </Menu.Item>
        } else {
            content = <Button size="mini" color="red" disabled={this.props.disabled} onClick={this.onClick}>
                {label}
            </Button>
        }
        return <>
            {this.renderModal()}
            {content}
        </>
    }
}

export const UnassignButtonRRC = ReduxReusableComponents.connectRRC(UnassignButtonState, Reducers, UnassignButton);
